import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "@/components/ui/dialog/Dialog";
import { Button } from "@/components/ui/button/Button";
import { DualPanelItemSelector } from "@/components/screener/DualPanelItemSelector";
import {
  CONTRIBUTION_COLUMNS,
  type ContributionColumnDef,
} from "./contributionColumns";

interface ContributionColumnSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  selectedColumns: string[];
  onColumnsChange: (columns: string[]) => void;
  availableColumns?: ContributionColumnDef[];
}

export function ContributionColumnSelector({
  isOpen,
  onClose,
  selectedColumns,
  onColumnsChange,
  availableColumns = CONTRIBUTION_COLUMNS,
}: ContributionColumnSelectorProps) {
  const [localSelectedColumns, setLocalSelectedColumns] =
    useState<string[]>(selectedColumns);

  useEffect(() => {
    setLocalSelectedColumns(selectedColumns);
  }, [selectedColumns]);

  const handleApply = () => {
    const columns = localSelectedColumns.includes("name")
      ? localSelectedColumns
      : ["name", ...localSelectedColumns];
    onColumnsChange(columns);
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} size="2xl">
      <DialogTitle>Select and Order Columns</DialogTitle>
      <DialogBody>
        <DualPanelItemSelector
          items={availableColumns}
          selectedIds={localSelectedColumns}
          onSelectionChange={setLocalSelectedColumns}
          searchPlaceholder="Search columns..."
          availableTitle="Available Columns"
          selectedTitle="Selected Columns"
          emptyMessage="No columns selected"
        />
      </DialogBody>
      <DialogActions>
        <Button onClick={onClose} plain>
          Cancel
        </Button>
        <Button onClick={handleApply} color="indigo">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
}
